<mbs-form-group class="mb-0 text-sm">
  <mbs-select [items]="items"
              [label]="label"
              [formControl]="control"
              [virtualScroll]="true"
              [loading]="loading"
              [bindLabel]="bindLabel"
              [appendTo]="appendTo"
              [clearable]="clearable"
              [searchable]="searchable"
              [placeholder]="placeholder"
              [isAutoWidth]="true"
              [isCheckboxSelect]="multiple"
              [isCounterShowing]="multiple && !!counterLabel"
              [labelForCounter]="counterLabel"
              [typeahead]="typeahead$"
              [multiple]="multiple"
              (clear)="clearEvent.next()"
              (close)="closeEvent.next()"></mbs-select>
</mbs-form-group>
